import React from "react";
import {
  stylesGenericInputLabelCP,
  stylesGenericInputLabelContainerTerlcel,
} from "../../../styles/genericInputLabel";

class GenericInputLabel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      titleStyles: {},
    };
  }

  componentDidMount() {
    const { isContainerTelcel } = this.props;
    this.setState({
      titleStyles: isContainerTelcel
        ? stylesGenericInputLabelContainerTerlcel
        : stylesGenericInputLabelCP,
    });
  }

  render() {
    const {
      titleStyles: { wrapper, image, label },
    } = this.state;
    const { imgIcon, labelText, showIcon, handleOnClickLabelIcon, id } =
      this.props;
    return (
      <div style={wrapper}>
        <p style={label}>
          <span>{labelText}</span>
          {showIcon ? (
            <img
              src={imgIcon}
              style={image}
              onClick={(e) => handleOnClickLabelIcon(e, id)}
            />
          ) : (
            <></>
          )}
        </p>
      </div>
    );
  }
}
export default GenericInputLabel;
